<script>
  import ItemResponse from "./ItemResponse.svelte";
  import { lineInterpolateTypes } from "../../editor/component/mark";
  export let inputFocusAction,
    inputBlurAction,
    updateLayer,
    currLayer,
    currLayerPrev;
</script>

<!-- point -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-row">
    <h3 class="h-sub">Mark details</h3>
  </div>
</div>
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="select"
    token="interpolate"
    title="Interpolate"
    options={lineInterpolateTypes.map((d) => d.type)}
    optionNames={lineInterpolateTypes.map((d) => d.name)}
    value={currLayer.mark.interpolate !== undefined}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateLayer(event, "mark.interpolate", currLayerPrev);
    }}
  />
</div>
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="inline-check"
    token="point"
    title="Use point"
    value={currLayer.mark.point !== undefined}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateLayer(event, "mark.point", currLayerPrev);
    }}
  />
</div>
{#if currLayer.mark.point !== undefined}
  <!-- let lineSpecial = [
  { name: "Point", key: "point.point", value_type: "boolean", input_type: "inline-check" },
  { name: "Point filled", key: "point.filled", condition: "point.point", value_type: "boolean", input_type: "inline-check" },
  { name: "Point size", key: "point.size", condition: "point.point", value_type: "number", input_type: "size" },
] -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="inline-check"
      token="point-filled"
      title="Fill point"
      value={currLayer.mark.point?.filled}
      {inputFocusAction}
      {inputBlurAction}
      changeAction={(event) => {
        updateLayer(event, "mark.point.filled", currLayerPrev);
      }}
    />
  </div>
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="size"
      token="point-size"
      title="Point size"
      value={currLayer.mark.point?.size}
      {inputFocusAction}
      {inputBlurAction}
      changeAction={(event) => {
        updateLayer(event, "mark.point.size", currLayerPrev);
      }}
    />
  </div>
{/if}

<!-- endMark -->

<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="inline-check"
    token="endMark"
    title="Use a point at the end of line"
    value={currLayer.mark.endMark !== undefined}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateLayer(event, "mark.endMark", currLayerPrev);
    }}
  />
</div>